<template>

	<SimpleForm
		:onSubmit="onSubmit"
		:fields="[
			{
				label : 'First name',
				name : 'first_name',
				autofocus : true,
				required : true,
			},
			{
				label : 'Last name',
				name : 'last_name',
				required : true,
			},
			{
				label : 'Email',
				name : 'email',
				type : 'email',
				autocomplete : 'username',
				required : true,
			},
			{
				label : 'Organisation / Team name',
				name : !invite ? 'org_name' : null,
				required : !invite ,
			},
			{
				label : 'New Password',
				name : 'password',
				type : 'password',
				autocomplete : 'new-password',
				required : true,
			},
			// {
			// 	label : 'Beta Code',
			// 	label_help : 'Registration is currently only open to people with a beta code. Contact us to request yours.',
			// 	name : 'beta_code',
			// 	required : true,
			// },
		]"
		:model="invite ? {
			first_name : invite.first_name,
			last_name : invite.last_name,
			email : invite.email,
		} : null"
		submitText="Agree &amp; Create account"
	>
		<template v-slot:clickwrap>
			By creating an account with us, you agree to our <a :href="terms_url" target="_blank">General Terms and Conditions</a>.
		</template>
	</SimpleForm>

</template>

<script>

	import SimpleForm from '../components/SimpleForm';
	import utl from '../utl.js';

	export default {

		components : {
			SimpleForm,
		},

		props : ['autofocus','invite'],

		data() {
			return {
				terms_url : window.publicBaseUrl + '/terms',
			};
		},

		methods: {

			onSubmit : function(payload){
				var self = this;

				if(self.invite){
					payload.invite_id = self.invite.id;
				}

				return this.$store.dispatch('auth/register',payload)
						.then(function(){
							self.$router.push( (self.$route.query||{}).redirect || '/' );
						})
						;

			}
		}
	}

</script>